export function getUserTimeZone(): string {
	const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
	return timeZone;
}
